export default {
  common: {
    search: 'Search',
    reset: 'Reset',
    startTime: 'Start Time',
    endTime: 'End Time',
    to: 'to',
    mt4: 'MT4',
    detail: 'Details',
    publishPamm: 'Publish PAMM',
  },
  page: {
    tabs: {
      published: 'Published',
      approvedMemo: 'Approval Records',
      commissionRecord: 'Commission Records',
    },
    header: {
      totalBalance: 'Total Balance',
      todayPL: 'Today P/L',
      totalPL: 'Total P/L',
    },
    dayCircle: {
      days: 'Daily',
      weeks: 'Weekly',
      months: 'Monthly',
      month_end: 'Last Week of Month',
    },
    weekMap: {
      '1': 'Monday',
      '2': 'Tuesday',
      '3': 'Wednesday',
      '4': 'Thursday',
      '5': 'Friday',
      '6': 'Saturday',
      '7': 'Sunday',
    },
  },
  published: {
    filter: {
      placeholder: {
        searchName: 'Search PAMM name',
        type: 'Type',
        status: 'Status',
        range: ['Start Time', 'End Time'],
      },
      applyType: {
        social: 'Social',
        private: 'Private',
      },
      status: {
        ongoing: 'Ongoing',
        cleared: 'Cleared',
      },
    },
    table: {
      columns: {
        strategy_name: 'PAMM Name',
        type: 'Type',
        balance: 'Balance',
        net_value: 'Net Value',
        total_profit: 'Total P/L',
        performace_fee: 'Performance Fee',
        management_fee: 'Management Fee/Year',
        total_performace_fee: 'Total Management Fee',
        total_earn: 'Profit Sharing',
        total_share_fee: 'Share Commission',
        total_invite_fee: 'Invite Commission',
        status: 'Status',
        action: 'Actions',
      },
    },
    cycleMap: {
      day: 'Daily Settlement',
      week: 'Weekly Settlement',
      month: 'Monthly Settlement',
      month_last_week: 'Monthly Settlement',
    },
    addEdit: {
      labels: {
        name: 'PAMM Name',
        pammType: 'PAMM Type',
        commissionRatio: 'Performance Fee',
        managementYear: 'Management Fee/Year',
        dayCircle: 'Settlement Cycle',
        pic: 'PAMM Photo',
        desc: 'PAMM Description',
        shareCommission: 'Share Commission',
        inviteCommission: 'Invite Commission',
        optional: '(Optional)',
      },
      applyType: {
        social: 'Social',
        private: 'Private',
      },
      placeholders: {
        input: 'Please enter',
        inputNumber0To50: 'Please enter a value 0–50',
        shareFirstRatio: 'First-level sharer commission rate',
        shareSecondRatio: 'Second-level sharer commission rate',
      },
      table: {
        columns: {
          level: 'Commission Level',
          ratio: 'Commission Rate',
          action: '',
        },
      },
      rules: {
        integerRequired: 'Please enter a value greater than 0',
        rangeRequired: 'Please enter a value between 0 and 50',
        nameRequired: 'Please enter PAMM name',
        picRequired: 'Please select PAMM photo',
        descRequired: 'Please enter PAMM description',
        pammTypeRequired: 'Please select PAMM type',
      },
    },
  },
  approvedMemo: {
    filter: {
      placeholder: {
        status: 'Status',
        search: 'Search Application ID, PAMM name',
        type: 'Type',
        range: ['Start Time', 'End Time'],
      },
      statusOptions: {
        approving: 'Pending',
        approved: 'Approved',
        refused: 'Rejected',
      },
      applyTypeOptions: {
        purchase: 'Purchase',
        append: 'Append',
        redeem: 'Redeem',
        redeemAll: 'Redeem All',
      },
    },
    table: {
      columns: {
        pamm_name: 'PAMM Name',
        apply_id: 'Application ID',
        nickname: 'Customer Name',
        customer_id: 'Customer ID',
        apply_type: 'Type',
        amount: 'Amount',
        apply_time: 'Application Time',
        verify_time: 'Approval Time',
        refuse_reason: 'Rejection Reason',
        action: 'Actions',
      },
      action: {
        refuse: 'Reject',
        agree: 'Approve',
      },
      modal: {
        title: 'Investment Review',
        confirmContent: 'Are you sure to approve this application? This operation is irreversible.',
        refuseReason: 'Rejection Reason',
        refuseReasonPlaceholder: 'Please enter rejection reason',
        okText: 'Confirm',
        cancelText: 'Cancel',
        success: 'Review Succeeded',
      },
    },
  },
  commissionRecord: {
    filter: {
      placeholder: {
        cycleStart: 'Settlement Start Time',
        cycleEnd: 'Settlement End Time',
        search: 'Search customer name, email, sharer',
      },
    },
    table: {
      columns: {
        strategy_name: 'PAMM Name',
        settlementCycle: 'Settlement Period',
        customer_name: 'Customer Name',
        customer_id: 'Customer ID',
        initial_investment: 'Initial Investment',
        profit: 'Profit/Loss',
        account_balance: 'Account Balance',
        profit_earn: 'Investment Earnings',
        commission: 'Commission Amount',
        management_fee: 'Management Fee',
        share_commission: 'Share Commission',
        invite_commission: 'Invite Commission',
        settlement_time: 'Settlement Time',
      },
    },
  },
  detail: {
    breadcrumb: {
      list: 'Published',
      title: 'PAMM Details',
    },
    tabs: {
      purchaseCustomer: 'Purchasing Customers',
      commissionDetail: 'Profit Sharing Details',
    },
  },
  addPamm: {
    breadcrumb: {
      list: 'Published',
      title: 'Publish PAMM',
    },
    tabs: {
      accountInfo: 'Account Info',
      pammInfo: 'PAMM Info',
    },
    form: {
      serverType: { label: 'Server Type', required: 'Please enter server type' },
      accountType: { label: 'Account Type', required: 'Please enter account type' },
      leverage: { label: 'Leverage', placeholder: 'Please select', required: 'Please enter leverage' },
      currency: { label: 'Currency', required: 'Please enter currency' },
      submit: 'Continue',
    },
    actions: {
      prev: 'Previous',
      confirmPublish: 'Confirm Publish',
    },
    publish: {
      success: 'Published successfully',
    },
  },
  shareRecommend: {
    breadcrumb: {
      list: 'Share/Recommend',
      detail: 'Detail',
    },
    filter: {
      placeholder: {
        type: 'Participation Type',
        range: ['Start Time', 'End Time'],
      },
      typeOptions: {
        share: 'Share',
        recommend: 'Recommend',
      },
    },
    table: {
      columns: {
        copy_id: 'Signal ID',
        strategy_name: 'Signal Name',
        nickname: 'Follower',
        type: 'Type',
        follow_amount: 'Follow Amount',
        share_amount: 'My Share Commission',
        invite_amount: 'My Recommend Commission',
        status: 'Status',
        subscribeTime: 'Subscribe Time',
        action: 'Actions',
      },
      type: {
        share: 'Share',
        recommend: 'Recommend',
        shareRecommend: 'Share | Recommend',
      },
      status: {
        stopped: 'Stopped',
        ongoing: 'Ongoing',
      },
    },
    detail: {
      table: {
        columns: {
          settle_period: 'Settlement Period',
          share_fee: 'Share Commission',
          invite_fee: 'Invite Commission',
          calculate_time: 'Settlement Time',
        },
      },
      view: {
        signalId: 'Signal ID',
        follower: 'Follower',
        shareRate: 'Share Commission',
        inviteRate: 'Recommend Commission',
      },
      statistics: {
        followAmount: 'Follow Amount',
        shareFee: 'Share Commission',
        inviteFee: 'Recommend Commission',
      },
    },
  },
}